import React from 'react';
import { formatDate } from '../../utils/formatDate';

function EventInfo(props) {
    const event = props.event;

    let desc = event.tournamentDesc || '';
    if (desc.trim().length > 0) {
        desc += ' | ';
    }
    desc += formatDate(event.timestamp).formatted;

    return (
        <div className="d-flex align-items-center | mb_10_1_1">
            <div className="d-flex align-items-center event-info | mb_10_1_1_1">
                <span className="event-list__tournamentDesc text-medium grey | mb_10_1_1_1_1">{props.event?.tournamentDesc}</span>
            </div>
        </div>
    );
}

export default EventInfo;